import _toConsumableArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { useEffect, useCallback } from 'react';
import useSWR from 'swr';
import { safelyRequestIdleCallback } from '@peloton/analytics/safelyRequestIdleCallback';
import { isDefined } from '@peloton/types';
import { UsersFetchers } from '@webtv/data-fetch';
import { PELOTON_PLATFORM } from '@webtv/env';
import { setUser } from '@webtv/error-reporting-v2';

var useSegmentIdentify = function useSegmentIdentify() {
  return useCallback(function (userId) {
    return safelyRequestIdleCallback(function () {
      var _window$analytics;

      return (_window$analytics = window.analytics) === null || _window$analytics === void 0 ? void 0 : _window$analytics.identify(userId);
    });
  }, []);
};
/**
 * Calls in to the Segment and Error SDKs and identifies the user by id
 * Important, as the Segment call ties together all the data on the backend
 */


export var useIdentify = function useIdentify() {
  var identify = useSegmentIdentify();

  var _useSWR = useSWR.apply(void 0, _toConsumableArray(UsersFetchers.GetMe({
    pelotonPlatform: PELOTON_PLATFORM
  }, {}, {
    errorRetryInterval: 1000
  }))),
      data = _useSWR.data;

  useEffect(function () {
    if (isDefined(data) && isDefined(data.id)) {
      identify(data.id);
      setUser({
        id: data.id
      });
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */

  }, [data === null || data === void 0 ? void 0 : data.id]);
};